import React, { Fragment } from "react"
import './announcementService.scss'

import Navbar from '../../components/newNavbar/navbar'
import { Select } from '../../components/select/select'
// import newButton from '../../components/button/button'
// import ButtonText from '../../components/buttonText/buttonText'
import Loading from '../../components/loading/loading'
import CardFeatured from '../../components/cardFeatured/cardFeatured'
import CardFeaturedPro from '../../components/cardFeaturedPro/cardFeaturedPro'
import { Query } from "react-apollo"
import Input from '../../components/newInput/input'
import { AnunciosSkillID, SkillName } from '../../queries/anuncios'
import Footer from '../../components/newFooter/footer'
// import { toast } from 'react-toastify';
import ErrorM from '../../components/ErrorMessange/errormenssage'
import Alert from 'react-bootstrap/Alert'
import { Link } from 'react-router-dom'
import Back from '../../components/backButton/backButton'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from '../../queries/endpoint'
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'

export default class AnnouncementService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filtered: false,
      listfilter: [],
      anunFilter: [],
      citySelect: null,
      stateSelect: null,
      noPlayer: null,
      searchResult: null,
      cities: [],
      states: null,
      anuncios: null
    }

    this.states = []
    this.cities = []

    const LastURL = JSON.parse(sessionStorage.getItem('LastURL'));
    if (LastURL) {
      window.location.href = LastURL.perfil
    }

    // this.skillURL = decodeURI(window.location.pathname.split('/')[(window.location.pathname.split('/').length - 1)].replace('+', '/'))
    this.skillURL = window.location.pathname.split('/')[(window.location.pathname.split('/').length - 1)].replace('+', '/')
  }

  finder = (query) => {
    // console.log(query)
    this.query = query
    this.setState({ searchResult: null })
    if (query !== undefined && query.length > 2) {
      const client = new GraphQLClient(endpoint)

      client.request(`
            {
                allUsers(
                  filter: {
                    OR: [
                      {
                        address: {
                        city_contains: "${query}"
                      }
                      },
                      {
                        name_contains: "${query}"
                      },
                      {
                        anuncios_some: {
                          OR: [
                            {
                              description_contains: "${query}"
                            },
                            {
                              skills: {
                          name_contains: "${query}"
                        }
                            }
                          ],
                          AND: [
                            {
                              active: true
                            }
                          ]
                      }
                      }      
                    ],
                    AND: [
                      {
                        type: PROFISSIONAL
                      },
                      {
                        status: true
                      },
                      {
                        anuncioses_some: {
                          active: true
                        }
                      }
                    ]
                  }
                )
                {
                  name
                  type
                  photo
                  id
                  address {
                    city
                  }
                  ranks {
                    typeTo
                    media
                  }
                  anuncios {
                    active
                    description
                    skill {
                      name
                    }
                  }
                }
              }
            `).then(
        res => {
          // console.log(res)
          if (res.error) return <p>Algo de errado aconteceu. Tente novamente.</p>
          this.setState({ listfilter: res.allUsers })
          if (res.allUsers.length < 1) {
            this.setState({ searchResult: <ErrorM content='Não foi encontrado nenhum anúncio ou profissional.' /> })
          }
        }
      )
    } else if (query === '' || query.length <= 2) {
      this.setState({ listfilter: [] })
      // if (this.state.listfilter.length > 0) {
      //   this.setState({ listfilter: [] })
      // }
    }
  }

  stateFilter = (state) => {
    // this.setState({ content: false })
    // console.log(state)

    if (state === "clean") {
      this.cities = []
      this.query = ""
      document.querySelector('#dropdown-state').selectedIndex = 0
      this.setState({ stateSelect: null, anunFilter: [], citySelect: null, cities: [] })
    } else {
      this.query = state
      const playersList = this.anunList;
      this.setState({ stateSelect: state })

      let anun = [];

      if (playersList && playersList.length && state) {
        playersList.filter(player =>
          player.player.address.state
            .toString()
            .toLowerCase()
            .includes(state.toLowerCase()) ?
            anun = [
              ...new Set([...anun, player])
            ] : null
        )
      }
      // console.log("statefilter", anun.length)
      if (anun.length > 0) {
        anun.map(player => (
          player.player.address ?
            this.cities = [
              ...new Set([...this.cities, player.player.address.city])
            ] : null
        ))
        if (this.cities.length > 0) this.setState({ cities: this.cities })
        // console.log(this.cities)

        this.setState({ anunFilter: anun })
      } else {
        this.setState({ noPlayer: <ErrorM color="danger" linkHref="https://oito.app/cadastro" link='Cadastre-se para ser o primeiro!' content='Infelizmente não encontramos nenhum profissional. ' /> })
      }

    }
  }

  cityFilter = (city) => {
    // this.setState({ content: false })

    if (city === "clean") {
      document.querySelector('#dropdown-cities').selectedIndex = 0
      this.stateFilter(this.state.stateSelect)
      this.setState({ citySelect: null, anunFilter: [] })
      // this.query = state
    } else {
      this.query = city
      const playersList = this.anunList;
      this.setState({ citySelect: city })

      let anun = [];

      if (playersList && playersList.length && city) {
        playersList.filter(player =>
          player.player.address.city
            .toString()
            .toLowerCase()
            .includes(city.toLowerCase()) ?
            anun = [
              ...new Set([...anun, player])
            ] : null
        )
      }
      // console.log("statefilter", anun.length)
      if (anun.length > 0) {
        this.setState({ anunFilter: anun })
      } else {
        this.setState({ noPlayer: <ErrorM color="danger" linkHref="https://oito.app/cadastro" link='Cadastre-se para ser o primeiro!' content='Infelizmente não encontramos nenhum profissional. ' /> })
      }

    }
  }

  render() {
    return (
      <Fragment>
        <div className={'AnnouncementService col-xs-12'}>
          <div className="row center-xs">
            <div className="col-xs-12" style={{ maxWidth: '600px' }}><Input placeholder={'Pesquisar...'} name={'search'} onInput={e => this.finder(e.target.value)} /></div>
            {this.state.searchResult}
          </div>

          {this.state.loading ? <Loading /> : null}

          <div className="row start-xs">
            <Back />
            <div className="buttonFilter col-xs-12" style={{ marginTop: "15px" }}>
              {this.state.states !== null ? <Select id={"dropdown-state"} onChange={(e) => this.stateFilter(e.target.value)} name={"Filtrar por estado"} placeholder={'Filtrar por estado'} itens={this.state.states} /> : null}
              {this.state.cities.length > 0 ? <Select id={"dropdown-cities"} onChange={(e) => this.cityFilter(e.target.value)} name={"Filtrar por cidade"} placeholder={'Filtrar por cidade'} itens={this.state.cities} /> : null}
            </div>

            {this.state.stateSelect ? <Alert id='selected' onClose={(e) => this.stateFilter("clean")} dismissible>{this.state.stateSelect}</Alert> : null}
            {this.state.citySelect ? <Alert id='selected' onClose={(e) => this.cityFilter("clean")} dismissible>{this.state.citySelect}</Alert> : null}

          </div>

          <div className="col-xs-12">
            <Query query={SkillName} variables={{ id: this.skillURL }}>
              {res => {
                if (res.error) return <p>Algo de errado aconteceu. Tente novamente.</p>
                // console.log(res.data.skill)
                if (res.data && res.data.skill) return <h1>Anúncios de { res.data.skill.name }</h1>
                else return null
              }}
            </Query>
          </div>

          <div className="col-xs-12">
            <Query query={AnunciosSkillID} variables={{ id: this.skillURL }}>
              {res => {
                if (res.loading) return <Loading />
                if (res.error) return <p>Algo de errado aconteceu. Tente novamente.</p>

                if (res.data && res.data.allAnuncios) {
                  const anuncios = res.data.allAnuncios

                  this.anunList = anuncios

                  // if (this.state.anuncios === null && anuncios.length > 0 ) this.setState({ anuncios: anuncios })

                  anuncios.map(player => (
                    player.player.address ?
                      this.states = [
                        ...new Set([...this.states, player.player.address.state])
                      ] : null
                    // this.states.push(player.player.address.state)
                  ))

                  if (this.states.length > 0 && this.state.states === null) this.setState({ states: this.states })

                  anuncios.map(player => {
                    let count = 0
                    player.player.ranks.map(med => (
                      med.typeTo === "PROFISSIONAL" ?
                        count = count + med.media : null
                    ))
                    player.total = (count / (player.player.ranks.length))
                    return null
                  })

                  return (
                    <div className={'sideSlide col-xs-12'}>
                      <div className="row around-xs center-xs">
                        {this.state.listfilter.length > 0 ? this.state.listfilter.map((player, i) => (
                          <ErrorBroundray key={i}><CardFeaturedPro name={player.name} photo={player.photo} link={player.id} mainJob={player.anuncios} /></ErrorBroundray>
                        )) :
                          this.state.anunFilter.length > 0 ? this.state.anunFilter.map((anun, i) => (
                            <ErrorBroundray key={i}><CardFeatured description={anun.description} avaliationStar={anun.total} mainJob={anun} salary={anun.price} photo={anun.player.photo} link={anun.player.id + '?' + this.skillURL} /></ErrorBroundray>
                          )) :
                            anuncios.length > 0 ? anuncios.map((anun, i) => {
                              return <ErrorBroundray key={i}><CardFeatured description={anun.description} avaliationStar={anun.total} mainJob={anun} salary={anun.price} photo={anun.files && anun.files.length > 0 ? anun.files : anun.player.photo} link={anun.player.id + '?' + this.skillURL} /></ErrorBroundray>
                            }) : <h4>Ainda não temos anúncios desta habilidade. Se você é profissional desta área, seja o primeiro a <Link to="/perfil/meuanuncios">cadastrar um anúncio.</Link></h4>}
                      </div>
                    </div>
                  )
                } else {
                  window.setTimeout(window.location.reload(), 500)
                  return <p>Aconteceu algo de errado. Vamos tentar de novo.</p>
                }
              }}
            </Query>
          </div>
        </div>
        <ErrorBroundray><Navbar /></ErrorBroundray>
        <div className='col-xs-12' style={{ marginLeft: "-0.5rem", marginTop: "50px"}}>
            <Footer />
          </div>
      </Fragment >
    )
  }
};

//<li key={i} onClick={() => window.location.href = "/anuncios/" + hab.name.replace('/','+') }>{hab.name}</li>
